import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import TextInput from 'components/Inputs/TextInput/TextInput';
import FormValidator from 'utils/FormValidator';
import ErrorConstants from 'utils/ErrorConstants';
import ErrorsUtils from 'utils/Errors';
import localeUtils from 'utils/LanguageLocale';

function PhoneField({
    phone = '',
    formattedPhone = '',
    isInternational = false,
    phoneInvalid = false,
    highlighted = false,
    isFCFinalReleaseEnabled = false,
    isSubscription = false,
    modalTitle = '',
    localization = {},
    onChange,
    phoneNumberRef,
    fireFormErrorAnalytics
}) {
    const { phone: phoneLabel = 'Phone Number' } = localization;
    const isUS = localeUtils.isUS();

    const validatePhoneNumber = phoneNumber => {
        if (FormValidator.isEmpty(phoneNumber)) {
            if (isSubscription && fireFormErrorAnalytics) {
                fireFormErrorAnalytics(modalTitle, ErrorsUtils.getMessage(ErrorConstants.ERROR_CODES.PHONE_NUMBER));
            }

            return ErrorConstants.ERROR_CODES.PHONE_NUMBER;
        }

        if (!isInternational && phoneNumber.length !== FormValidator.FIELD_LENGTHS.formattedPhone) {
            if (isSubscription && fireFormErrorAnalytics) {
                fireFormErrorAnalytics(modalTitle, ErrorsUtils.getMessage(ErrorConstants.ERROR_CODES.PHONE_NUMBER_INVALID));
            }

            return ErrorConstants.ERROR_CODES.PHONE_NUMBER_INVALID;
        }

        return null;
    };

    return (
        <TextInput
            name='phone'
            label={phoneLabel}
            autoComplete={isFCFinalReleaseEnabled ? (isInternational ? 'tel' : 'tel-national') : 'tel'}
            autoCorrect='off'
            type='tel'
            maxLength={isInternational ? FormValidator.FIELD_LENGTHS.internationalPhone : FormValidator.FIELD_LENGTHS.formattedPhone}
            required={true}
            hideAsterisk={isUS || isFCFinalReleaseEnabled}
            invalid={phoneInvalid}
            highlighted={highlighted}
            value={formattedPhone || phone}
            ref={phoneNumberRef}
            onKeyDown={FormValidator.inputAcceptOnlyNumbers}
            onChange={onChange}
            validateError={validatePhoneNumber}
            data-at={Sephora.debug.dataAt('phone_number_input')}
            dataAtError={Sephora.debug.dataAt('phone_number_required_error')}
        />
    );
}

export default wrapFunctionalComponent(PhoneField, 'PhoneField');
